import { render, staticRenderFns } from "./AbsenceRequestImport.vue?vue&type=template&id=01455352&"
import script from "./AbsenceRequestImport.vue?vue&type=script&lang=js&"
export * from "./AbsenceRequestImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports